import { useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'
import Button from 'src/components/ui/Button'
import Icon from 'src/components/ui/Icon'

import { useKitlook } from '../../context/KitlookContext'

type CashbackInformationModalProps = {
  setIsKitlookModalOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const KitlookDetailsModal = ({
  setIsKitlookModalOpen,
}: CashbackInformationModalProps) => {
  const modalRef = useRef<HTMLDivElement>(null)
  const { hasPrev, hasNext, prevKit, nextKit, currentKit } = useKitlook()
  const totalItems = currentKit?.products.length ?? 0
  const labelItems = totalItems === 1 ? 'item' : 'itens'
  const kitInfo = `${currentKit?.name} (${totalItems} ${labelItems})`

  const handleClickOutside = (event: MouseEvent) => {
    const eventTarget = event.target as Node | null

    if (modalRef.current === eventTarget) {
      setIsKitlookModalOpen(false)
    }
  }

  useEffect(() => {
    if (!document) {
      return () => {}
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  })

  return createPortal(
    <div
      className="cashback-info-modal-backdrop bg-[#15181bcc] fixed z-[9999999] top-0 left-0 w-full h-full flex items-center justify-center"
      ref={modalRef}
    >
      <div className="bg-[#fff] w-full max-w-[375px] mx-4relative flex flex-col justify-center">
        <div className="relative flex items-center justify-end h-12">
          <Button
            icon={<Icon name="BlackCloseIcon" width={24} height={24} />}
            iconPosition="right"
            onClick={() => {
              setIsKitlookModalOpen(false)
            }}
            className="flex items-center justify-center absolute top-3 right-3 w-6 h-6"
          />
        </div>
        <div className="p-6">
          <p className="font-medium text-restructure-primary text-xl">
            {kitInfo}
          </p>
          <p className="font-medium text-sm text-restructure-primary  my-6">
            {currentKit?.description}
          </p>

          {hasPrev && (
            <button
              onClick={prevKit}
              type="button"
              className="cursor-pointer bg-transparent border-none p-0 font-bold text-primaryBlue hover:underline text-sm"
            >
              Ver Kit anterior
            </button>
          )}

          {hasNext && (
            <button
              onClick={nextKit}
              type="button"
              className="cursor-pointer bg-transparent border-none p-0 font-bold text-primaryBlue hover:underline text-sm"
            >
              Ver próximo Kit
            </button>
          )}
        </div>
      </div>
    </div>,
    document.body
  )
}

export default KitlookDetailsModal
